/**
 * 编辑单个部门
 */
import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';
export interface IEditInput {
    parent_department_id: string;
    department_name: string;
    manager_umu_ids: string;
    department_id: string;
}
export interface IEditOutput {
    status: number;
    desc: string;
}
export const editDepartment = (data: IEditInput) => {
    return fetchData(Api.EDIT_DEPARTMENT, data).then((res: IResponse<IEditOutput>) => {
        return res.data;
    });
};
